"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
exports.eof = {
    type: 'unclassified',
    char: '',
};
function getInitialTokenizeState() {
    return {
        offset: 0,
        startOffset: 0,
        phase: Phase.initial,
        context: getInitialSyntacticContext(),
        characters: [],
    };
}
exports.getInitialTokenizeState = getInitialTokenizeState;
/**
 * @param characters 토큰화에 사용할 코드 문자열입니다.
 * @param state 토큰화 상태입니다.
 *              이전 토큰화 처리중 중간에 끊어진 상태를 이어받아서 계속 처리할 수 있습니다.
 *              인자로 넣어준 상태는 토큰화 처리중 변경됩니다.
 * @param eofCharacter 토큰화를 끝맺기 위한 코드 문자입니다.
 */
function tokenize(characters, state, eofCharacter) {
    var e_1, _a, endToken, characters_1, characters_1_1, character, pushResult, e_1_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (state === void 0) { state = getInitialTokenizeState(); }
                if (eofCharacter === void 0) { eofCharacter = exports.eof; }
                endToken = function (pushResult) {
                    if (state.startOffset == null)
                        throw new Error(); // assertion
                    var type = (pushResult[0] === 'emit') ? pushResult[1] : 'unknown';
                    var offset = state.startOffset;
                    var length = state.offset - offset;
                    if (length === 0)
                        throw new Error(); // assertion
                    state.startOffset = state.offset;
                    state.phase = Phase.initial;
                    state.characters = [];
                    return { type: type, offset: offset, length: length };
                };
                _b.label = 1;
            case 1:
                _b.trys.push([1, 9, 10, 11]);
                characters_1 = __values(characters), characters_1_1 = characters_1.next();
                _b.label = 2;
            case 2:
                if (!!characters_1_1.done) return [3 /*break*/, 8];
                character = characters_1_1.value;
                pushResult = void 0;
                _b.label = 3;
            case 3:
                pushResult = pushTable[state.phase](character, state);
                if (pushResult[2]) {
                    state.characters.push(character);
                    state.offset += character.char.length;
                }
                if (!(pushResult[0] === 'continue')) return [3 /*break*/, 4];
                state.phase = pushResult[1];
                return [3 /*break*/, 6];
            case 4:
                if (!(pushResult[0] === 'emit')) return [3 /*break*/, 6];
                return [4 /*yield*/, endToken(pushResult)];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6:
                if (!pushResult[2]) return [3 /*break*/, 3];
                _b.label = 7;
            case 7:
                characters_1_1 = characters_1.next();
                return [3 /*break*/, 2];
            case 8: return [3 /*break*/, 11];
            case 9:
                e_1_1 = _b.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 11];
            case 10:
                try {
                    if (characters_1_1 && !characters_1_1.done && (_a = characters_1.return)) _a.call(characters_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 11:
                if (!eofCharacter)
                    return [2 /*return*/];
                if (state.startOffset == null)
                    return [2 /*return*/];
                return [4 /*yield*/, endToken(pushTable[state.phase](eofCharacter, state))];
            case 12:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
exports.tokenize = tokenize;
function getInitialSyntacticContext() {
    return {
        blocks: [{
                keywords: new Set([
                    'assert', 'break', 'continue', 'else', 'false',
                    'fn', 'for', 'if', 'new', 'package',
                    'pub', 'return', 'static', 'switch', 'syntax',
                    'test', 'true', 'type', 'use', 'var',
                    'yield',
                ]),
            }],
    };
}
exports.getInitialSyntacticContext = getInitialSyntacticContext;
function hasKeyword(context, keyword) {
    return !!context.blocks.find(function (block) { return block.keywords.has(keyword); });
}
exports.hasKeyword = hasKeyword;
function guessTokenTypeFromPhase(phase) {
    switch (phase) {
        default: return 'unknown';
        case Phase.whitespace: return 'whitespace';
        case Phase.newline: return 'newline';
        case Phase.newlineCr: return 'newline';
        case Phase.comment: return 'comment';
        case Phase.opening_grouping: return 'opening_grouping';
        case Phase.closing_grouping: return 'closing_grouping';
        case Phase.punctuation: return 'punctuation';
        case Phase.unquoted_name: return 'unquoted_name';
        case Phase.quoted_name: return 'quoted_name';
        case Phase.number_literal: return 'number_literal';
        case Phase.quoted_literal: return 'quoted_literal';
    }
}
exports.guessTokenTypeFromPhase = guessTokenTypeFromPhase;
var Phase;
(function (Phase) {
    Phase[Phase["initial"] = 0] = "initial";
    Phase[Phase["whitespace"] = 1] = "whitespace";
    Phase[Phase["newline"] = 2] = "newline";
    Phase[Phase["newlineCr"] = 3] = "newlineCr";
    Phase[Phase["comment"] = 4] = "comment";
    Phase[Phase["opening_grouping"] = 5] = "opening_grouping";
    Phase[Phase["closing_grouping"] = 6] = "closing_grouping";
    Phase[Phase["punctuation"] = 7] = "punctuation";
    Phase[Phase["unquoted_name"] = 8] = "unquoted_name";
    Phase[Phase["quoted_name"] = 9] = "quoted_name";
    Phase[Phase["number_literal"] = 10] = "number_literal";
    Phase[Phase["quoted_literal"] = 11] = "quoted_literal";
})(Phase || (Phase = {}));
var pushTable = (_a = {},
    _a[Phase.initial] = function (character) {
        switch (character.type) {
            case 'closing_grouping': return ['continue', Phase.closing_grouping, false];
            case 'closing_quote': return ['emit', 'unknown', true];
            case 'decimal_digit': return ['continue', Phase.number_literal, false];
            case 'horizontal_space': return ['continue', Phase.whitespace, false];
            case 'name_continue': return ['emit', 'unknown', true];
            case 'name_start': return ['continue', Phase.unquoted_name, false];
            case 'opening_grouping': return ['continue', Phase.opening_grouping, false];
            case 'opening_quote': return ['continue', Phase.quoted_literal, false];
            case 'punctuation': return ['continue', Phase.punctuation, false];
            case 'toggling_quote': return ['continue', character.char === '`' ? Phase.quoted_name : Phase.quoted_literal, false];
            case 'vertical_space': return ['continue', Phase.newline, false];
            case 'unclassified': return ['emit', 'unknown', true];
        }
    },
    _a[Phase.whitespace] = function (character) {
        if (character.type === 'horizontal_space')
            return ['continue', Phase.whitespace, true];
        return ['emit', 'whitespace', false];
    },
    _a[Phase.newline] = function (character) {
        if (character.type === 'vertical_space') {
            if (character.char === '\r')
                return ['continue', Phase.newlineCr, true];
            return ['continue', Phase.newline, true];
        }
        return ['emit', 'newline', false];
    },
    _a[Phase.newlineCr] = function (character) {
        return ['emit', 'newline', character.char === '\n'];
    },
    _a[Phase.comment] = function (character) {
        if (character.type !== 'vertical_space')
            return ['continue', Phase.comment, true];
        return ['emit', 'comment', false];
    },
    _a[Phase.opening_grouping] = function (character) {
        if (character.type === 'opening_grouping')
            return ['continue', Phase.opening_grouping, true];
        return ['emit', 'opening_grouping', false];
    },
    _a[Phase.closing_grouping] = function (character) {
        if (character.type === 'closing_grouping')
            return ['continue', Phase.closing_grouping, true];
        return ['emit', 'closing_grouping', false];
    },
    _a[Phase.punctuation] = function (character, _a) {
        var characters = _a.characters;
        if (character.type === 'punctuation') {
            if ((characters.length === 1) &&
                (characters[0].char === '-') &&
                (character.char === '-')) {
                return ['continue', Phase.comment, true];
            }
            return ['continue', Phase.punctuation, true];
        }
        return ['emit', 'punctuation', false];
    },
    _a[Phase.unquoted_name] = function (character, _a) {
        var characters = _a.characters, context = _a.context;
        if ((character.type === 'name_start') ||
            (character.type === 'name_continue') ||
            (character.type === 'decimal_digit'))
            return ['continue', Phase.unquoted_name, true];
        if ((characters.length === 1) && (characters[0].char === '_')) {
            return ['emit', 'placeholder_name', false];
        }
        if (hasKeyword(context, characters.map(function (character) { return character.char; }).join(''))) {
            return ['emit', 'keyword', false];
        }
        return ['emit', 'unquoted_name', false];
    },
    _a[Phase.quoted_name] = function (_character, _a) {
        var characters = _a.characters;
        if (characters.length === 1)
            return ['continue', Phase.quoted_name, true];
        if (characters[characters.length - 1].char !== '`')
            return ['continue', Phase.quoted_name, true];
        return ['emit', 'quoted_name', false];
    },
    _a[Phase.number_literal] = function (character) {
        // TODO
        if (character.type === 'decimal_digit')
            return ['continue', Phase.number_literal, true];
        return ['emit', 'number_literal', false];
    },
    _a[Phase.quoted_literal] = function (_character, _a) {
        var characters = _a.characters;
        // TODO
        if (characters.length < 2)
            return ['continue', Phase.quoted_literal, true];
        var first = characters[0].char;
        var last = characters[characters.length - 1].char;
        if (first !== last)
            return ['continue', Phase.quoted_literal, true];
        return ['emit', 'quoted_literal', false];
    },
    _a);
function cloneTokenizeState(tokenizeState) {
    return __assign({}, tokenizeState, { characters: __spread(tokenizeState.characters), context: cloneSyntacticContext(tokenizeState.context) });
}
exports.cloneTokenizeState = cloneTokenizeState;
function equalsTokenizeState(a, b) {
    return ((a.phase === b.phase) &&
        (a.offset === b.offset) &&
        (a.startOffset === b.startOffset) &&
        iterEq(a.characters.values(), b.characters.values()));
}
exports.equalsTokenizeState = equalsTokenizeState;
function cloneToken(token) {
    return {
        type: token.type,
        offset: token.offset,
        length: token.length,
    };
}
exports.cloneToken = cloneToken;
function equalsToken(a, b) {
    if (!a)
        return !b;
    if (!b)
        return !a;
    if (a.type !== b.type)
        return false;
    if (a.offset !== b.offset)
        return false;
    if (a.length !== b.length)
        return false;
    return true;
}
exports.equalsToken = equalsToken;
function cloneSyntacticContext(context) {
    return {
        blocks: context.blocks.map(cloneSyntacticContextBlock),
    };
}
exports.cloneSyntacticContext = cloneSyntacticContext;
function equalsSyntacticContext(a, b) {
    if (a.blocks.length !== b.blocks.length)
        return false;
    return iterEq(a.blocks.values(), b.blocks.values());
}
exports.equalsSyntacticContext = equalsSyntacticContext;
function cloneSyntacticContextBlock(block) {
    return {
        keywords: new Set(__spread(block.keywords)),
    };
}
exports.cloneSyntacticContextBlock = cloneSyntacticContextBlock;
function equalsSyntacticContextBlock(a, b) {
    if (a.keywords.size !== b.keywords.size)
        return false;
    return iterEq(a.keywords.values(), b.keywords.values());
}
exports.equalsSyntacticContextBlock = equalsSyntacticContextBlock;
function iterEq(a, b) {
    var _a;
    var ar, br;
    do {
        _a = __read([a.next(), b.next()], 2), ar = _a[0], br = _a[1];
        if (ar.value !== br.value)
            return false;
        if (ar.done !== br.done)
            return false;
    } while (!ar.done);
    return true;
}
